import { render, staticRenderFns } from "./ChartDoubleTemplate.vue?vue&type=template&id=37d8abb2&scoped=true&"
import script from "./ChartDoubleTemplate.vue?vue&type=script&lang=js&"
export * from "./ChartDoubleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d8abb2",
  null
  
)

export default component.exports